import React, {Component} from 'react';
import {
    Button,
    ButtonGroup,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledButtonDropdown,
    UncontrolledDropdown
} from 'reactstrap';
import Pagination from 'react-js-pagination';
import Spinner from 'react-spinkit';
import HTML from '../../common/HtmlHelpers';
import Utils from '../../common/Utils';
import _ from 'lodash';
import './CRUDView.css';
import SessionStateManager from '../../common/SessionStateManager';
import AppVariables from "../../common/AppVariables";
import UserNotifications from "../../common/UserNotifications/UserNotifications";
import {Dialogs} from "../../common/Constants";
import TTLProxy from "../../common/TTLAsyncProxy";
import AppGlobals from "../../common/AppGlobals";
import PlatformContainer from "../PlatformContainer/PlatformContainer";
import NotificationHandler from "../../common/NotificationHandler";
import ProgressBar from 'react-md-progress-bar';
import FormRenderer from '../../common/FormRenderer/FormRenderer';
import {Default, Desktop, isMobile, Mobile} from "../../common/ResponsiveUtils";
import Icon from 'react-icons-kit';
import {ic_check} from 'react-icons-kit/md/ic_check';
import {ic_more_vert as MoreIconVert} from 'react-icons-kit/md/ic_more_vert'
import DocumentTitle from 'react-document-title';
import Confirm from "../Confirm/Confirm";
import SortColumn from "../../common/SortColumn";
import CurrencyLabel from "../CurrencyLabel/CurrencyLabel";
import JsonTable from "../ReactJsonTable/ReactJsonTable";
import DialogCollapseSection from "../DialogCollapseSection";
import FilterQueryWrapper from "../FilterQueryWrapper/FilterQueryWrapper";
import SortDialog from './Components/SortDialog';
import EventListener from "../../common/EventListener";
import NumberLabel from "../NumberLabel/NumberLabel";
import DropdownList from "./Components/DropdownList";
import Chip from "../Chip/Chip";
import ActiveView from "../../common/ActiveView";
import {ic_close as CloseIcon} from 'react-icons-kit/md/ic_close';
import PermissionRender from "../PermissionRender/PermissionRender";
import {getSetting} from "../../common/LocalSettings/LocalSettings";
import {getEventEmitter, handleBrowserUnload} from "../../common/Events/EventSource";

//  Define View mode
const ViewMode = Object.freeze({

    //  Display just paginated items
    Normal: 0,

    //  Display search results
    Search: 1

});

//  Define Search Mode
const SearchMode=  Object.freeze({
    Immediate: 'immediate',
    Explicit: 'explicit'
});

const Styles = {

    modalHeader:{
        backgroundColor: '#8080800f'
    },

    chipStyle: {
        closeBtnColor: "#000000",
        labelColor: "#000000",
        color: "#cdcdcd"
    }
};

export const CustomFilterFrame = ({ children , padding , toggle }) => {
    return <div className={`${padding === undefined ? 'p-4' : '' } mb-4`} style={{
        backgroundColor: "rgb(247, 247, 247)" ,
        borderRadius: 2,
        boxShadow: "0 1px 3px #c5baba",
        padding
    }}>
        {toggle && <div className="clearfix" style={{ marginTop: -5}}>

            <div className="pull-right">
                <span style={{ cursor: "pointer" }} onClick={toggle}><Icon icon={CloseIcon}/></span>
            </div>
        </div>}
        {children}
    </div>
};


/**
 * Handles Create, Read, Update and Delete of entities
 */
class CRUDView extends Component {

    /**
     * The session manager for the view
     */
    session;

    /**
     * The TTL-Core (API) communication processor
     * @type {*}
     */
    proxy = TTLProxy.getInstance();

    /**
     * Manages the events of tractors
     */
    events = getEventEmitter();

    /**
     * Indicates the component is mounted
     * @type {boolean}
     * @private
     */
    _isMounted = false;

    /**
     * The current display state of the view
     * @type {{mobile: boolean}}
     * @private
     */
    _viewState = { mobile : false };


    constructor(props,name) {

        super(props);

        //  initialize session manager
        const restoreEnabled = this.isSessionRestoreEnabled();
        this.session = new SessionStateManager(name || this.constructor.name ,  restoreEnabled );

        //  set the default state
        let initialState = {

            //  Dialog's is open
            dialogOpen: false,

            //  The currently active dialog
            activeDialog: -1,

            //  The title of the confirm dialog
            confirmTitle: 'Confirm Title',

            //  The message in the confirm dialog
            confirmMessage: 'Confirm message',

            //  The text on the confirm button
            confirmPositiveText: 'Confirm',

            //  The text on the cancel button
            confirmCancelText: 'Cancel',

            //  The handler for confirm accepted handler
            confirmAcceptedHandler: null,

            //  current items in view
            items: [],

            //  the total number of items in the current page
            pageItemsCount: 0,

            //  holds checked items
            checkMap: [],

            //  page loaded?
            isLoaded: false,

            //  the current page
            activePage: 1,

            //  maximum items per page
            maxItemsPerPage: this.getTotalItemsPerPage(),

            //  indicates there's something running at the moment. You react by disabling all input sources
            isBusy: false,

            //  The actual total number of the items
            totalItems: 0,

            //  Indicates we encountered an error during a recent operation
            faulted: false,

            //  The error message to show
            errorMessage: null,

            //  The item that's in the context of being deleted
            deleteItem: null,

            //  The item that's in the context of being edited
            editItem : null,

            //  The item that's in the context of detail display
            detailItem: null,

            //  Holds columns to display in view
            columns: [],

            //  Dynamic search keyword..Changes on every keystroke
            searchKeyword: null,

            //  Static search keyword... Changes only when search is hit
            searchKeywordStatic : null,

            //  Showing toolbox??
            hasToolbox: false,

            //  Showing search bar??
            hasSearch: false,

            //  Indicates current view mode
            viewMode: ViewMode.Normal,

            //  holds filter state
            filterState: [],

            //  holds order state
            orderState: [ '-date_created' ],

            //  Indicates a toolbox dropdown group which is open
            toolboxDropdown: {},

            //  Holds selection indices for dropdown items
            toolboxSelectionMap:  {},

            //  This is the error shown in dialogs during processing
            processingError: null,

            //  Prevent dialog from closing
            preventDialogClose: false,

            //  Custom filter visible
            customFilterVisible: this.session.getState('customFilterVisible',false),

            //  Custom filter state
            customFilterState: this.getCustomFilterState({}),

            //  Get initial state
            ...this.getInitialState(props),

        };

        //  restore state
        if(restoreEnabled){

            initialState = {
                ...initialState,
                ...this.onRestoreSessionState(this.session)
            };

        }

        this.state = initialState;

        //  capture view state settings
        this._viewState.mobile = AppGlobals.get('isMobile');

        //  toggles dialogs
        this.toggleDialog = this.toggleDialog.bind(this);
        this.renderCustomFilterView = this.renderCustomFilterView.bind(this);
        this.toggleCustomFilterVisibility = this.toggleCustomFilterVisibility.bind(this);
        this._handleQueryChange = this._handleQueryChange.bind(this);
        this._handleEvent = this._handleEvent.bind(this);
    }

    getTotalItemsPerPage(){
        return Number(getSetting("items_per_page",AppVariables.MaxItemsPerPage));
    }

    getSearchMode(){
        return getSetting("search_input_mode") || "explicit";
    }

    onRefreshActiveView(){
        this.loadPage(1);
    }

    /**
     * Returns the custom filter state
     * @returns {{}}
     */
    getCustomFilterState(filters){
        return { }
    }

    /**
     * Gets the initial state for the component
     * @param props
     */
    getInitialState(props){
        return { };
    }

    /**
     * Restore session into state
     * @param sessionManager
     */
    onRestoreSessionState(sessionManager){
        return {};
    }

    onEvent(evt, callback){
        this.events.once(evt,callback);
    }

    /**
     * Checks whether the component is mounted
     * @returns {boolean}
     */
    isMounted() {
        return this._isMounted;
    }

    /**
     * Set the state safely. This ensures the view is mounted
     * @param state
     * @param callback
     */
    setStateSafe(state,callback){

        if(this._isMounted){
            this.setState(state,callback);
        }

    }

    componentDidMount(){

        //  Persist session on browser unload
        handleBrowserUnload(() => this.persistSession());
    }

    configureSort(){

        const viewOptions = this.viewOptions;
        if(viewOptions.hasOwnProperty('sort')){
            this._sortDlg.show( this.state.orderState.join(",") ,viewOptions.sort.properties);
        }

    }

    /**
     * Clears the current order state
     */
    clearOrderState(){

        this.setState({
            orderState: []
        },() => {
            this.refresh();
        });

    }

    setOrderStateUnique(field){

        //  prevent unwanted updates
        if(this.state.orderState.length === 1 && this.state.orderState[0] === field){
            return;
        }

        //  set order state unique
        this.setStateSafe({
            orderState:  field  ? [field] : [],
        },() => {
            //  refresh view
            this.refresh();
        });


    }

    setOrderState(field , clearSame){

        let orderState = this.state.orderState;
        let didChange = false;
        if(clearSame && orderState.indexOf(field) >= 0 ){
            orderState.splice(orderState.indexOf(field),  1);
            didChange = true;
        }
        else{

            //
            if(orderState.indexOf(field) < 0) {
                orderState.push(field);
                didChange  = true;
            }
        }

        if(didChange){

            //
            this.setState({
                orderState: orderState
            });

            //  refresh view
            this.refresh();
        }
    }

    /**
     * Returns backend api proxy
     * @returns {*}
     */
    getProxy(){
        return this.__proxy || (this.__proxy = TTLProxy.getInstance());
    }

    /**
     * Gets checked items
     * @returns {Array}
     */
    getCheckedItems(){

        if(!this.isValidState())
            return [];

        return this.state.checkMap;
    }

    /**
     * Handles item check changed
     * @param e
     * @param item
     */
    onHandleCheckChanged(e,item){

        let checkMap  = this.state.checkMap;

        if(e.target.checked)
            checkMap.push(item);
        else
            checkMap.splice( this.state.checkMap.indexOf(item) , 1);

        //  update state
        this.setState({
            checkMap: checkMap
        });

    }

    findItemIndex(item){
        return this.state.items.findIndex((i) => this.compareItems(i,item) );
    }

    renderSelectCheckBox(item){

        const me = this;
        const checked= this.isItemChecked(item);
        return  <input checked={checked}
                       type="checkbox"
                       onChange={(e) => me.onHandleCheckChanged(e,item)}/>;
    }

    renderCheckedState(){

        return <input type="checkbox"
                      checked={this.isAllSelected()}
                      onChange={(evt) => {

                              if(!this.isAllSelected())
                                  this.selectAll();
                              else
                                  this.clearSelection();

                      }}/>

    }

    isItemChecked(item){
        const id = this.getItemId(item);
        return !!this.state.checkMap.find(x => this.getItemId(x) == id);
    }

    handleSortSelection(key,order){

        if(order == null || order === "") {
            this.clearOrderState();
        }
        else{
            this.setOrderStateUnique((order === "desc" ? "-" : "") + key);
        }
    }

    hasOrderState(key){

        const order = this.state.orderState;
        if(order.includes(key))
            return "asc";

        if(order.includes(`-${key}`))
            return "desc";

        return null;
    }

    sortCol(label,key){
        return <SortColumn label={label} isActive={true} onChange={this.handleSortSelection.bind(this,key)} order={this.hasOrderState(key)} />;
    }

    getColumns({ mobileOnly }) {

        let columns = [];

        const cellRender = this.renderCell.bind(this);
        const checkBoxRender = this.renderSelectCheckBox.bind(this);

        //
        if(this.viewOptions.multiSelection.enable) {
            columns.push({ key: '__select' , label:  () => this.renderCheckedState() , cell: checkBoxRender });
        }

        let _columns = this.viewOptions.columns;

        if(mobileOnly)
            _columns = _columns.filter(x => x.mobile === true);

        for(let i = 0 ; i < _columns.length; i++){

            let cl = _columns[i];
            if (cl['detailOnly'] || (this._viewState.mobile && cl.mobile !== true)) {
                continue;
            }

            if(!cl.cell){
                cl.cell = cellRender;
            }

            //  append column
            columns.push(cl);

        }

        //  allow edit and delete
        if(this.viewOptions.actions.edit.enabled ||
            this.viewOptions.actions.delete.enabled) {
            columns.push({ key: '__actions', label: ' ' , cell: this.renderCellActions.bind(this) })
        }

        return columns;
    }

    setViewOptions(opts){

        //  update view options
        this.viewOptions = opts;

        // Update window title
        let features = opts.features;
        let hasToolbox = features ? features.indexOf("toolbox") >= 0 : false;
        let hasSearch = features ?  features.includes("search") >= 0 : false;
        this.setState({
            hasToolbox: hasToolbox,
            hasSearch: hasSearch,
            //maxItemsPerPage: opts.maxItemsPerPage,
            columns: this.getColumns({ mobileOnly: false }),
            columnsMobile: this.getColumns({ mobileOnly: true }),
            toolboxDropdown: {}
        });

        //
        if(this.viewOptions.channels){

            const notif = NotificationHandler.getInstance();

            Object.keys(this.viewOptions.channels).forEach((k) => {

                let channel  = this.viewOptions.channels;
                if(channel.events){

                    channel.events.map(e => {

                        //  subscribe to channel
                        notif.subscribeChannelEvent(k,e ,(message) =>{
                            this.onReceiveNotification(k,e,message);
                        });

                    });

                }

            });

        }

        //  set component mounted
        this._isMounted = true;
    }

    /**
     * Called when a notification is received from any pusher channel. This can be used to trigger and update UI accordingly
     * @param channel The source channel
     * @param event The event in the channel
     * @param message The message sent
     */
    onReceiveNotification(channel , event , message){

    }

    /**
     * Override this method to enable/disable session restore
     * @returns {boolean}
     */
    isSessionRestoreEnabled(){
        return true;
    }

    setDefaultViewOptions(){

        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No items available yet!',

            //  The class icon for the card header
            pageIcon: 'fa',

            //  The title for the content frame
            pageTitle: 'Items',

            //  Set no frame for views
            noFrame: true,

            //  The total number of items per page
            //maxItemsPerPage: 10,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            //  The message to show when loading items
            busyMessage: 'Please hold on...',

            //  define channels,
            channels: {

                //
                /*core_notifications_channel: {
                    'add':{
                        'actions': [
                            'refresh',
                            {
                                action: 'clear_session',
                                arg: 'tractor_owners'
                            }
                        ]
                    },

                }*/

            },

            //  Called to render portions of the view before final display
            renderHooks:{

                //  rendered before list view
                header: null,

                //  rendered after list view
                footer: null

            },

            multiSelection: {

                //  enable multi-selection
                enable : true,
            },

            hooks:{

                //  Called before every query to get items
                preQueryHook: null,

                //  Called after any CRUD operation
                //  Args: (action: String, arg: Object)
                postProcessorHook: null

            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create:{
                    text: 'Create',
                    successCreateMsg: 'Created successfully!',
                    failCreateMsg : 'Failed creating!',
                    enabled: true,
                    editTitleMsg: 'Edit',
                    createTitleMsg: 'Add'
                },

                //  delete action options
                delete:{

                    enabled : false,

                    //  Disallows the deleting of many items ??
                    disallowMany: false,

                    successDeleteMsg: 'Deleted successfully!',
                    failDeleteMsg: 'Failed deleting',
                    text: 'Delete',
                    confirmTitle: 'Confirm Delete',
                    confirmMessage: 'Are you sure you want to delete item?',

                    //  The message to show when deleting many items
                    confirmManyMessage: 'Delete selected items?'
                },

                //  delete action options
                edit:{
                    enabled : false,
                    successEditMsg: 'Edited successfully!',
                    failEditMsg: 'Failed editing',
                    text: 'Edit'
                }

            },

            queryActions: {

                //  The endpoint for communication. When set, overrides get and search query methods
                endpoint: null
            },

            //  Indicates filters that can set through query parameters
            filters: {

                /*'state':{
                    validate: 'number'
                },

                'color': {

                }*/
            },

            display: {

                //  The class for a row
                rowClass: null
            },

            //  Defines additional model properties
            models:{

                //  properties to include
                include: null
            },

            search:{

                //
                placeholder: 'Search items...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: SearchMode.Immediate,

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  Holds searchable properties of models. If not set, the default properties will be used on the server
                properties: []
            },

            //  Defines actions for toolbox
            toolBox: [],

            //  Inputs used in editing and creating items
            inputs: [],

            // Describes the columns present in the table
            columns : [],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,

                //  called to render the title of the dialog if defined
                renderTitle: (item) => { return "Item Description"; },

                //  Indicates whether the dialog is larger
                large: false,

                //  called to render the display window content if defined
                customRender: undefined,

                //  The properties to render in the details dialog
                properties: [],

                //  Called to render to footer for the details dialog
                renderFooter: null,

                //  Invokes before showing
                onShow: null
            },

            //  Processors
            processors :{

                //  called to get content value for a cell
                getCellValue: (item,key) => {
                    return item[key];
                },

                //  called to get the value of an input field
                getInputValue : (name, input) =>{
                    return input.value;
                },

                //  called to set the input value
                //  This method is an overrider. If implemented, overrides the default implementation
                setInputValue: (name,input , value) => {
                    input.value = value;
                },

                //  create new item
                createItem: (proxy , payload) =>{
                },

                //  called to delete many items
                deleteMany: (proxy,items) =>{
                },

                //  on edit item
                onEditItem: (proxy,item, inputs  ) => {
                },

                //  on delete item
                onDeleteItem: ( proxy,item ) => {
                },

                //  called when an item is clicked
                onItemClick: (e, item) => {

                },
            }
        });
    }

    /**
     * Process delete many requests
     */
    handleDeleteMany(){

        //  we can begin to confirm
        const proxy = this.getProxy();
        const selectedItems  = this.state.deleteItem;
        let me = this;
        let state = this.state;

        //
        if(selectedItems === null || !Array.isArray(selectedItems) ){
            return;
        }

        this.setState({
            isBusy: true
        });

        //
        return this.handleProcessorResponse(this.viewOptions.processors.deleteMany(proxy, selectedItems), (response) => {

            //  call hook
            me.invokePostProcessorHook('delete-many',response);

            if(response.ok) {

                let activePage = me.state.activePage;
                if ((state.items.length - selectedItems.length) <= 0) {
                    activePage = Math.max(activePage - 1, 1);
                    if(!me.handlePageChange(activePage)){
                        me.refresh();
                    }

                }
                else {
                    me.refresh();
                }

            }

        },(err) => {

            HTML.toastError("Failed deleting selected items!");

            return me.setState({
                isBusy: false
            });

        });
    }

    /**
     * Renders Edit,Delete buttons when enabled
     * @param item
     * @param key
     */
    renderCellActions(item,key) {

        const viewOptions = this.viewOptions;
        const actions = viewOptions.actions;
        const isBusy = this.state.isBusy && !this.state.dialogOpen;

        return  <UncontrolledDropdown>

            <DropdownToggle color={"link"}><Icon icon={MoreIconVert}/></DropdownToggle>

            <DropdownMenu right style={{ left: "inherit" }}>
                {actions.edit.enabled && <PermissionRender required={actions.edit.permissions}><DropdownItem onClick={this.beginEdit.bind(this,item)}><i className="fa fa-edit"></i> Edit</DropdownItem></PermissionRender>}
                {actions.delete.enabled && <PermissionRender required={actions.delete.permissions}><DropdownItem disabled={typeof actions.delete.isAllowed == "function" ? !viewOptions.actions.delete.isAllowed(item) || isBusy  : isBusy} onClick={this.onConfirmDelete.bind(this,item)}><i className="fa fa-remove"></i> Delete</DropdownItem></PermissionRender>}
                {(viewOptions.hooks && viewOptions.hooks.renderCellActions) ? viewOptions.hooks.renderCellActions(item).map((action,key) => {
                        const _component = (<DropdownItem key={key} onClick={() => action.onClick(item)} disabled={action.disabled || isBusy} color="link">{HTML.renderIcon(action.icon)} <Desktop component="span">{action.label}</Desktop></DropdownItem>);
                        return action.hasOwnProperty('permissions') ? <PermissionRender key={key} required={action.permissions}>{_component}</PermissionRender> : _component;
                    }
                ) : null}
            </DropdownMenu>

        </UncontrolledDropdown>;
    }

    /**
     * Refresh current view
     */
    refresh() {

        const { viewMode , activePage , searchKeyword } = this.state;

        switch (viewMode) {
            case ViewMode.Search:
                return this.executeSearch(searchKeyword , activePage );
            case ViewMode.Normal:
                return this.loadPage(activePage);
        }

    }

    //  format cell value
    processCellFormat(frame,item,value,key) {

        if(typeof frame.format === "string") {

            //  switch default formatting options
            switch (frame.format){
                case "date":
                    return Utils.formatDateStandard(value);
                case 'date_long':
                    return Utils.formatDateLong(value);
                case "trimmed":
                    let v = value ? value.trim() : '';
                    return v.length === 0 ? undefined : v;
                case 'integer':
                    return value.toLocaleString();
                case 'money':
                    return <CurrencyLabel value={value}/>;
            }

        }
        else if(Array.isArray(frame.format)){

            // process booleans to support array indices
            if(typeof value === "boolean")
                value = value === true ? 1 : 0;

            let map = frame.format;
            if(value >= 0 && value < map.length){
                return map[value];
            }

            return "N/A";
        }
        else if(typeof frame.format === "function"){

            try{
                value = frame.format(value,item);
            }catch(ex){
                value = "N/A";
            }

        }

        return value;
    }

    /**
     * Get value for cell
     * @param item
     * @param key
     * @returns {string}
     */
    getCellValue(item,key){
        let frame = this.viewOptions.columns.find((k) => k.key == key);
        let value = this.viewOptions.processors.getCellValue ? this.viewOptions.processors.getCellValue(item,key) : ( (frame && frame.format) ? this.processCellFormat(frame,item,item[key],key) : item[key]);
        return value === null ? "N/A" : value;
    }

    /**
     * Render cell content
     * @param item
     * @param key
     * @returns {string}
     */
    renderCell(item ,key) {
        return this.getCellValue(item,key);
    }

    /**
     * Shows edit dialog for editing item
     * @param item
     */
    beginEdit(item){
        this.beginShowDialog({ editItem: item , activeDialog: Dialogs.CreateOrEdit , confirmBtnColor: "primary" });
    }

    /**
     * Renders detail dialog for the specified item
     * @param item
     */
    beginShowDetails(item){
        this.beginShowDialog({ detailItem: item , activeDialog : Dialogs.Details , confirmBtnColor: "primary"   });
    }

    /**
     * Opens create dialog
     */
    beginShowCreate(){
        this.beginShowDialog({activeDialog: Dialogs.CreateOrEdit , confirmBtnColor: "primary"  });
    }

    clearSelection(){
        this.setState({ checkMap: [] });
    }

    selectAll(){

        if(this.viewOptions.multiSelection.enable){
            this.setState({ checkMap : this.state.items.slice() });
        }
    }

    /**
     * Returns whether all items are checked
     * @returns {boolean}
     */
    isAllSelected(){
        return (this.state.checkMap.length === this.state.items.length) && (this.state.totalItems !== 0);
    }

    /**
     * Checks custom filter is visible
     * @returns {boolean}
     */
    isCustomFilterViewVisible(){
        return this.state.customFilterVisible;
    }

    /**
     * Toggles custom filter visibility
     */
    toggleCustomFilterVisibility(){

        this.setStateSafe({
            customFilterVisible: !this.state.customFilterVisible
        });

    }

    /**
     * Render custom filter view
     */
    renderCustomFilterView(){

        const viewOptions = this.viewOptions;
        if(viewOptions.hasOwnProperty('renderCustomFilters') && this.state.customFilterVisible){

            return viewOptions.renderCustomFilters({

                filters: this.getQueryFilters(),

                orderState: this.state.orderState,

                resetValues: (nextFilters) => {

                    this.setStateSafe({
                        customFilterState: _.isNil(nextFilters) ? this.getCustomFilterState({ }) : nextFilters
                    });

                },

                setValues: (values) => this.setStateSafe({

                    customFilterState: {
                        ...this.state.customFilterState,
                        ...values
                    }
                }),

                setValue: (key,value) => this.setStateSafe({

                    customFilterState: {
                        ...this.state.customFilterState,
                        [key]: value
                    }

                }),

                values: this.state.customFilterState,

                toggle: this.toggleCustomFilterVisibility,

                applyFilters: (customFilters) => {

                    this.setQueryFiltersRaw(flt => ({
                        ...flt,
                        ...customFilters
                    }));

                }
            });

        }

        return null;
    }

    /**
     * Render tools in the toolbox
     */
    renderToolbox(){

        const me = this;
        const leftActions = this.viewOptions.toolBox.filter((item) => item.position === 'left' || !item.position );
        const rightActions = this.viewOptions.toolBox.filter((item) => item.position === 'right' );
        const anySelected = this.state.checkMap.length;

        //  group actions
        function groupActions(actions) {

            let groups = {};
            function appendGroup(key ,action) {
                if(groups[key]){
                    groups[key].push(action);
                }
                else{
                    groups[key] = [action];
                }
            }

            for(let i = 0 ; i  < actions.length; i ++){
                let action = actions[i];
                appendGroup(action.group || "__empty",action);
            }

            return groups;
        }


        const leftGrouped = groupActions(leftActions);
        const rightGrouped = groupActions(rightActions);
        const defaultActions = <ButtonGroup>
            {this.viewOptions.actions.delete.enabled && <PermissionRender required={this.viewOptions.actions.delete.permissions}>
                <Button color={anySelected ? "danger" : null} disabled={!anySelected || this.state.isBusy} onClick={() =>{

                    if(anySelected){

                        if(this.state.checkMap.length === 1){
                            me.onConfirmDelete(this.state.checkMap[0]);
                        }
                        else {
                            me.onConfirmDeleteMany(me.state.checkMap);
                        }
                    }
                }}><i className="fa fa-trash"/> <Desktop component="span">{"Delete"}</Desktop></Button>
            </PermissionRender>}

        </ButtonGroup>;

        return <React.Fragment>

            <DropdownList ref={r => this._listPortal = r}/>

            <Default>
                <div className="clearfix" style={{ marginBottom: '10px' }}>
                {this.viewOptions.multiSelection.enable && <div className="pull-left">{defaultActions}</div>}
                {leftActions.length > 0 && me.renderActionsGroup(leftGrouped,'left')}
                {rightActions.length > 0 && me.renderActionsGroup(rightGrouped,'right')}
            </div>
            </Default>

            <Mobile>
                <DialogCollapseSection title={<b>Actions</b>} initiallyOpen={false} >
                    <Row className="mb-2">

                        <Col md={6} sm={12} xs={12}>
                            {this.viewOptions.multiSelection.enable && <div className="pull-left">{defaultActions}</div>}
                            {me.renderActionsGroup(leftGrouped)}
                        </Col>

                        <Col md={6} sm={12} xs={12}>
                            {me.renderActionsGroup(rightGrouped)}
                        </Col>

                    </Row>
                </DialogCollapseSection>
            </Mobile>

        </React.Fragment>


    }

    renderActionsGroup(actionsGrouped , alignment){

        const keys = Object.keys(actionsGrouped);
        const keysLength = keys.length;
        const me = this;
        const state = this.state;

        function handleSelection(group,sIndex,clearSame) {

            let selMap = me.state.toolboxSelectionMap;
            if(selMap[group] == sIndex){

                if(!clearSame)
                    return;

                delete selMap[group];
            }
            else {
                selMap[group] = sIndex;
            }

            me.setState({
                toolboxSelectionMap: selMap
            });
        }

        function getItemText(item) {

            if(typeof item.text === "function")
                return item.text();

            return item.text;
        }

        return (<div className={alignment !== undefined ? ("pull-" + alignment) : null}>

            {keys.map((group , i) => {
                    return (<ButtonGroup
                        style={i < keysLength- 1 ? {marginRight: '10px'} : null} key={i}>
                        {actionsGrouped[group].map((item,kIndex) => {

                            let _element;

                            if(item.items){

                                const items = (typeof item.items === "function"? item.items() : item.items) || [];
                                const disabled = (state.isBusy && !state.dialogOpen) || this.state.faulted || items === undefined;

                                if(item.withPortal){

                                    const options = item.portalOptions || {};
                                    _element = <Button style={item.style} className={me.state.toolboxSelectionMap.hasOwnProperty(group) ? 'toolbox-group-active' : ""} disabled={disabled} key={kIndex} onClick={() => {

                                        this._listPortal.show({
                                            items: items,
                                            title: options.title || "Select an item",
                                            itemStyle: options.itemStyle,
                                            selected: me.state.toolboxSelectionMap.hasOwnProperty(group) ? items[me.state.toolboxSelectionMap[group]] : null,
                                            selectCallback: (selectedItem,sIndex) => {

                                                let _res = item.invoke ? item.invoke(sIndex) : null;
                                                if(item.sticky && _res !== false) {
                                                    handleSelection(group, sIndex, !item.selectOnce);
                                                }

                                            }
                                        });

                                    }}>
                                        {item.icon ? HTML.renderIcon(item.icon) : null} <Desktop component="span">{getItemText(item)}</Desktop>
                                    </Button>

                                }
                                else {

                                    _element = <UncontrolledButtonDropdown style={item.style} key={kIndex} disabled={disabled}>
                                        <DropdownToggle disabled={disabled} className={me.state.toolboxSelectionMap.hasOwnProperty(group) ? 'toolbox-group-active' : ""} caret> {item.icon ? HTML.renderIcon(item.icon) : null} <Desktop component="span">{getItemText(item)}</Desktop> </DropdownToggle>
                                        <DropdownMenu disabled={disabled} right={alignment === 'right'} style={{ left: alignment === 'right' ? 'inherit' : undefined }} >
                                            {
                                                items.map((subItem,sIndex) => {

                                                    const selected = me.state.toolboxSelectionMap[group] == sIndex;
                                                    return (<DropdownItem className={item.sticky ? (selected ? (item.activeClassName || "toolbox-btn-active"):  "") : ""} onClick={() =>
                                                    {
                                                        let _res = item.invoke ? item.invoke(sIndex) : null;
                                                        if(item.sticky && _res !== false) {
                                                            handleSelection(group, sIndex, !item.selectOnce );
                                                        }

                                                    }} key={sIndex} disabled={disabled}>
                                                        <div className="clearfix">
                                                            <div className="pull-left">
                                                                {subItem}
                                                            </div>
                                                            {selected && <div className="pull-right">
                                                                <Icon icon={ic_check}/>
                                                            </div>}
                                                        </div>

                                                    </DropdownItem>);
                                                })}
                                        </DropdownMenu>
                                    </UncontrolledButtonDropdown>

                                }

                            }
                            else {

                                const className = `${typeof item.className == "function" ? item.className() : item.className} ${item.sticky ? (me.state.toolboxSelectionMap[group] == kIndex ? (item.activeClassName || "toolbox-btn-active") : "") : ''}`;
                                _element = <Button color={item.color} style={item.style} onClick={() =>{

                                    if(item.sticky) {
                                        handleSelection(group, kIndex);
                                    }

                                    if(item.invoke)item.invoke();

                                }} key={kIndex} className={className} disabled={ (this.state.isBusy && !this.state.dialogOpen) || this.state.faulted}>{item.icon ? HTML.renderIcon(item.icon) : null} <Desktop component="span">{getItemText(item)}</Desktop></Button>
                            }

                            return item.hasOwnProperty('permissions') ? <PermissionRender key={kIndex} required={item.permissions}>{_element}</PermissionRender> : _element;
                        })}
                    </ButtonGroup>);
                }
            )}
        </div>);
    }

    /**
     * Set query filters raw
     */
    setQueryFiltersRaw(callback,refresh = true){

        if(!this._filterWrapper)
            return ;

        return this._filterWrapper.setFiltersRaw(callback , refresh);
    }

    /**
     * Returns filter value
     * @param key
     * @param defaultValue
     * @returns {*}
     */
    getQueryFilter(key,defaultValue = undefined){
        return this._filterWrapper ? this._filterWrapper.getFilterValue(key,defaultValue) : defaultValue;
    }

    /**
     * Gets query filters
     * @returns {{limit, filters, page}}
     */
    getQueryFilters(){
        return this._filterWrapper ? this._filterWrapper.getFilters() : undefined;
    }

    /**
     * Render search input
     * */
    renderSearch(style){

        return (<InputGroup style={style}>
            <input type="text"
                   style={{ width: '18em' }}
                   ref={r => this.search_input = r}
                   onKeyPress={(e) => {

                        if(e.key === 'Enter') {
                            this.onSearchClicked();
                        }
                   }}
                   value={this.state.searchKeyword || ''}
                   className={"form-control form-input-select"}
                   placeholder={this.viewOptions.search.placeholder || "Search items here"}
                   onChange={this.onSearchValueChanged.bind(this)} />

            <button className="search-addon search-button" onClick={this.onSearchClicked.bind(this)}><span className="fa fa-search" /></button>
        </InputGroup>);
    }


    /**
     * Updates query string with given key and value
     * @param key
     * @param value
     */
    updateQuery(key,value){

        this._filterWrapper.onApplyFilters({
            [key]: value
        });

    }

    _buildFiltersQuery({ filterId ,...filters}){

        const viewOptions = this.viewOptions;
        if(_.isArray(viewOptions.filters)){

            let _filters = [];
            Object.keys(filters).map(k => {

                const flt = viewOptions.filters.find(x => x.key === k);
                if(flt && flt.apply === true)
                    _filters.push({ key: flt.filterKey || k , value: filters[k] , operator: _.isFunction(flt.operator) ? flt.operator(filters) : (flt.operator || "") })


            });

            if(!_.isNil(filterId)){
                _filters.push({ key: 'id', value: filterId , operator: '=' })
            }

            return _filters;
        }

    }

    /**
     * Returns the parameters for querying data with current view state
     */
    getQueryParams(opts){

        const {  filters: { search , orderBy  , ..._filters }  , page , limit } = this._filterWrapper.getFilters();


        return {
            pagination: { perPage: limit , page: opts.page === undefined ? page : opts.page },
            filter: Object.keys(_filters).length > 0 ? this._buildFiltersQuery(_filters) : undefined,
            sort: this.state.orderState.length > 0 ? this.state.orderState : undefined,
            include: this.viewOptions.model ? this.viewOptions.model.include :  undefined,
            search: search ? { keyword: search , method: 'inside' , fields: this.viewOptions.search.properties || undefined } : undefined
        };

    }

    executeSearch(keyword, page) {

        const me = this;

        this.setState({ isBusy: true });

        function run() {

            let endpoint = me.viewOptions.queryActions.endpoint;
            let currentPage =  page || me.state.activePage;

            let params = {
                ...me.getQueryParams({page : page}),
                method: "get"
            };

            //
            if(me.onExecuteRequest)
                me.onExecuteRequest(endpoint,params,me._filterWrapper.getFilters());

            return me.execReq(endpoint,params).then((response) => {

                let items = response.getPayload();
                let actualCount = response.getPayloadCount();
                if(actualCount > 0 && items.length === 0){

                    return me._filterWrapper.setFiltersRaw(({ filterId,  ...filters }) => ({
                        ...filters,
                        page: 1
                    }));

                }

                //  set total items for search
                me.setStateSafe({
                    totalItems: actualCount,
                    items: items,
                    isBusy: false,
                    faulted: false,
                    errorMessage: null,
                    viewMode: ViewMode.Search,
                    activePage: currentPage
                });

                //
                me.persistSession();

            }).catch((err) => {

                me.enterErrorState(undefined, () => {

                    //
                    me.setStateSafe({
                        faulted: false,
                        errorMessage: null
                    });

                    //  execute search again
                    run();

                });

            });

        }

        //  run search
        return run();
    }

    onSearchValueChanged(evt){

        const me = this;
        const searchMode = this.getSearchMode();
        let value = evt.target.value;

        this.setStateSafe({
            searchKeyword: value
        });

        //
        if(searchMode.toLowerCase() === SearchMode.Explicit){

            if(value === ""){

                this._filterWrapper.setFiltersRaw(({ filterId,  search,  ...filters }) => ({
                    ...filters,
                    page: 1
                }));

            }

            return;
        }

        //
        if(this._searchTimer)
            window.clearTimeout(this._searchTimer);

        this._searchTimer = window.setTimeout(() => {

                value = me.search_input.value;

                //
                this._filterWrapper.setFiltersRaw(({ filterId , page , ...filters }) => ({
                    ...filters,
                    page: 1,
                    search: value || undefined
                }), true );


        },830);

    }

    onSearchClicked(evt){

        const filterWrapper = this._filterWrapper;

        if(this.state.searchKeyword === '' || this.state.searchKeyword === null){

            //  focus on search input
            this.search_input.focus();

            return;
        }

        //  no changes detected
        if(this.state.searchKeywordStatic === this.state.searchKeyword && !this.state.faulted)
            return;

        //
        filterWrapper.setFiltersRaw(({ filterId , ...filters }) => ({
            ...filters,
            search: this.state.searchKeyword
        }), true);

    }

    /**
     * Exec Request
     * @param url
     * @param opts
     * @returns {Promise|*}
     */
    execReq(url,opts){
        return this.getProxy().processRequest(url,opts);
    }

    /**
     * Retrieves a single record from database
     * @param id
     * @returns {Promise.<TResult>}
     */
    getItemSingle(id){

        const queryActions = this.viewOptions.queryActions;
        let query;
        if(queryActions.endpointSingle){

            query = {
                url : queryActions.endpointSingle,
                get: id,
                include: this.viewOptions.model ? this.viewOptions.model.include :  undefined
            };

        }
        else if(queryActions.endpoint){

            query = {
                url: queryActions.endpoint,
                get: Number(id),
                include: this.viewOptions.model ? this.viewOptions.model.include :  undefined
            };

        }

        //  get single item
        return this.execReq(query).then((response) => {
            return response.getPayload();
        });
    }

    /**
     * Updates a single item
     * @param id
     */
    updateItemSingle(id){

        const me = this;
        return this.getItemSingle(id).then((item) => {

            let items = me.state.items;
            let index = items.findIndex((stuff) => me.compareItems(stuff,item) );
            if(index > 0){

                items[index] = item;
                me.setState({
                    items: items
                });

            }

            return item;
        });
    }

    getDialogRenderer(dialog){

        switch (dialog){
            case Dialogs.CreateOrEdit:
                return this._createEditRenderer;
        }
    }

    handleProcessorResponse(res,pass,fail){

        if(res) {
            return res.then(pass).catch(fail);
        }

        //  close dialog
        return Promise.resolve(true);
    }

    /**
     * Handle edit item
     */
    onEditItem(formData){

        const me = this;
        const proxy = this.proxy;
        let state = this.state;
        const item = state.editItem;
        let difference = Utils.getDifference(item,formData); // gets changed form data


        //  nothing to update
        if(Object.keys(difference).length === 0)
            return;

        //  clear errors
        this._createEditRenderer.clearErrors();

        //  enter busy state
        me.setStateSafe({
            isBusy: true
        });

        //  TODO: Handle item edit here

        return this.handleProcessorResponse(this.viewOptions.processors.onEditItem(proxy, item , formData, difference ), (response) => {

            //  clear busy - immediate
            me.setStateSafe({
                isBusy: false
            });

            //  no-update
            if(!response){
                return Promise.resolve(false);
            }

            //  call hook
            me.invokePostProcessorHook('edit',response);

            //  succeeded
            if(response.ok) {

                //  refresh edited item
               return  me.getItemSingle( me.getItemId(item) ).then((item) => {

                    //
                    let items = me.state.items;
                    let index = items.findIndex((stuff) => me.compareItems(stuff,item) );
                    if(index >= 0){
                        items[index] = item;
                    }

                    //  succeeded editing
                    HTML.toastSuccess(this.viewOptions.actions.edit.successEditMsg);

                    //
                    me.setState({
                        items: items
                    });


                    return true; //succeeded

                }).catch((err) => {

                    //  just refresh view
                    me.refresh();

                    // return true to close the dialog if open
                    return true;
                });


            }

        },(err) => {

            //  clear busy state
            me.setStateSafe({
                isBusy: false
            });

            //  precondition failed??
            if(err.response && err.response.status === 412){

                //
                UserNotifications.showConcurrentUpdateError();

                //
                this._createEditRenderer.setStatusError('Failed: Someone committed changes before you just did! Please refresh and try again');

            }
            else{

                //  leave to processor error handler...
                me.handleProcessorStatus(err);
            }

            //  return false to keep the dialog still alive
            return false;

        });

    }

    /**
     * Shows a confirmation dialog to delete item
     */
    onConfirmDelete(item,callback){

        this.beginShowDialog({
            activeDialog: Dialogs.Confirm,
            confirmTitle: this.viewOptions.actions.delete.confirmTitle,
            confirmMessage:  this.viewOptions.actions.delete.confirmMessage,
            confirmPositiveText: this.viewOptions.actions.delete.text,
            confirmCancelText: 'Cancel',
            confirmBtnColor: "danger",
            confirmAcceptedHandler: this.onDeleteItem.bind(this,callback),
            deleteItem: item
        });

    }

    /**
     * Show confirmation dialog to delete many items
     * @param items
     */
    onConfirmDeleteMany(items){

        this.beginShowDialog({
            activeDialog: Dialogs.Confirm,
            confirmTitle: this.viewOptions.actions.delete.confirmTitle,
            confirmMessage:  this.viewOptions.actions.delete.confirmManyMessage,
            confirmPositiveText: this.viewOptions.actions.delete.text,
            confirmCancelText: 'Cancel',
            confirmBtnColor: "danger",
            confirmAcceptedHandler: this.handleDeleteMany.bind(this),
            deleteItem: items
        });
    }

    /**
     * Handle delete item
     */
    onDeleteItem(callback,deleteItem){

        let state = this.state;
        const proxy = this.proxy;
        const item = deleteItem || state.deleteItem;
        const maxItemsPerPage = this.getTotalItemsPerPage();
        const me = this;

        //
        this.setState({
            isBusy: true
        });

        // TODO: Handle item delete. Remember to set isBusy to false when done
        return this.viewOptions.processors.onDeleteItem(proxy,item).then((response) => {

            //  call hook
            me.invokePostProcessorHook('delete',response);

            if(response.ok) {

                //  delete operation was successful
                const items = state.items;
                let index = items.findIndex((stuff) => me.compareItems(stuff,item) );
                let activePage = state.activePage;

                if(index === -1){
                    return;
                }

                items.splice(index, 1);

                if(items.length === 0){
                    activePage = Math.max(activePage - 1 , 1);
                }

                //  Toast message
                HTML.toastSuccess(this.viewOptions.actions.delete.successDeleteMsg);

                if(callback){

                    try {
                        callback();
                    }
                    catch(ex) {
                        //  Handled here
                    }

                }

                if(state.pageItemsCount < maxItemsPerPage && state.activePage !== activePage){

                    //  update active page and no need to refresh
                    me.handlePageChange(activePage);
                }
                else{

                    me.setState({
                        activePage: activePage
                    });

                    //  refresh view
                    return me.refresh();
                }
            }

        }).catch((err) => {

            HTML.toastError(this.viewOptions.actions.delete.failDeleteMsg || Utils.getResponseError(err) );

            return this.setState({
                isBusy: false
            });

        });
    }


    /**
     * Returns whether in loaded state
     * @returns {boolean}
     */
    isLoaded(){
        return this.state.isLoaded && !!this.viewOptions;
    }

    /**
     * Compares two items
     * @param left
     * @param right
     * @returns {boolean}
     */
    compareItems(left,right){
        return left.id === right.id;
    }

    /**
     * Returns a unique identifier for the specified item
     * @param item
     */
    getItemId(item){
        return item.id;
    }

    /**
     * Fetch items from server with defined endpoints using current view state. Thus includes the use of filters and order state etc...
     */
    queryData(page){

        const me = this;
        const proxy = this.proxy;
        const viewOptions = me.viewOptions;
        const endpoint =  viewOptions.queryActions.endpoint;
        page = page === undefined ? this.state.activePage : page;

        //
        function handleErrorState(err) {

            me.enterErrorState(Utils.getResponseError(err),() => {

                //  restore state to loading state
                me.setState({
                    isBusy: false,
                    faulted: false,
                    errorMessage : null
                });

                //  run query again
                run();

            });
        }

        function run() {

            //  pre-load hook
            if(viewOptions.hooks && viewOptions.hooks.preQueryHook){
                return viewOptions.hooks.preQueryHook().then(executeAsync).catch(handleErrorState);
            }
            else {
                return executeAsync();
            }

        }

        function executeAsync(state) {

            //  exclude search
            const { search , ...qParams } = me.getQueryParams({ page : page });

            let params = {
                ...qParams,
                method: "get",
                exclude: me._blacklistItems ? me._blacklistItems.map((i) => i.id ) : null
            };

            //  allow hooking request params
            if(me.onExecuteRequest)
                me.onExecuteRequest(endpoint,params,me._filterWrapper.getFilters());

            //  get total items
            return proxy.processRequest(endpoint, params).then((response) => {

                let items = response.getPayload();

                //  were there blacklisted items??
                if(me._blacklistItems && me._blacklistItems.length > 0) {

                    //  unset blacklist
                    me._blacklistItems = undefined;

                    //
                    let stateItems = me.state.items.slice();
                    for(let i = 0 ; i < items.length; i++) {

                        //  check whether item already exists
                        if(stateItems.findIndex((stuff) => me.compareItems(items[i],stuff)) === -1){
                            stateItems.push(items[i]);
                        }

                    }

                    //  set items
                    items = stateItems;
                }

                let actualCount = response.getPayloadCount();
                if(actualCount > 0 && items.length === 0){

                    return me._filterWrapper.setFiltersRaw(({ filterId,  search,  ...filters }) => ({
                        ...filters,
                        page: 1
                    }));

                }

                let _state = {
                    ...me.state,
                    ...state,
                    items: items,
                    totalItems:  actualCount,
                    isLoaded: true,
                    faulted: false,
                    isBusy: false,
                    viewMode: ViewMode.Normal,
                    checkMap: [],
                    pageItemsCount: items.length
                };


                me.setStateSafe(_state, () => me.persistSession());


            }).catch(handleErrorState);
        }


        //  run query
        return run();
    }


    /**
     * Persist Data
     **/
    getPersistData(){
       return {};
    }

    persistSession(){

        // persist some key items
        this.session.putStateFrame({
            ...this.getPersistData(),
            customFilterVisible: this.state.customFilterVisible
        }).save();
    }

    componentWillUnmount(){

        //
        const proxy = this.getProxy();

        //  Check whether persisting session is allowed
        if(this.isSessionRestoreEnabled()) {

            //  persist session
            if(proxy.isAuthenticated())
                this.persistSession();

        }
        else{

            //  clear session state
            this.session.reset();
        }

        this._isMounted = false;
    }

    /**
     * Loads the specified page
     */
    loadPage(pageNumber){

        //  set busy
        this.setStateSafe({ isBusy: true });

        return this.queryData(pageNumber);
    }

    handlePageChange(pageNumber, force = false){

        if(this.state.activePage !== pageNumber || force) {

            //  clear selection
            this.clearSelection();

            this.setQueryFiltersRaw(({ page , ...filters }) => ({
                ...filters,
                page: pageNumber
            }));

            return true;
        }

        return false;
    }

    handleProcessorStatus(err){

        //  check whether error detail was shipped along
        const formRenderer = this._createEditRenderer;
        formRenderer.updateException(err, true);

        this.setState({
            isBusy: false,
        });
    }

    invokePostProcessorHook(action,arg){

        const hooks =  this.viewOptions.hooks;
        if(hooks.postProcessorHook){
            hooks.postProcessorHook(action,arg);
        }
    }

    onCreate(formData) {

        let me = this;
        const proxy = this.proxy;

        this._createEditRenderer.clearErrors();

        this.setStateSafe({
            isBusy: true
        });

        //  TODO: Create item here
        return this.handleProcessorResponse(this.viewOptions.processors.createItem(proxy, formData),(response) =>{

            this.setStateSafe({
                isBusy: false
            });

            //  call hook
            me.invokePostProcessorHook('create',response);

            if(response.ok) {

                //  succeeded creating
                HTML.toastSuccess(me.viewOptions.actions.create.successCreateMsg);

                //  refresh view
                me.refresh();

                //  return true to indicates operation was successful
                return true;
            }
            else {

                console.warn("Failed creating. Server didn't return success status code");
            }

        },(err) => {

            //
            this.setStateSafe({
                isBusy: false
            });

            //  show toast failed message
            HTML.toastError(me.viewOptions.actions.create.failCreateMsg);

            //  handle status for processor call
            this.handleProcessorStatus(err);

            //  return false to keep dialog still alive
            return false;
        });

    }

    renderPagination() {

        const maxItemsPerPage = this.getTotalItemsPerPage();
        return this.state.items.length > 0 ? (<div className="float-left" key={this.state.activePage}><Pagination
            activePage={this.state.activePage}
            itemsCountPerPage={maxItemsPerPage}
            totalItemsCount={this.state.totalItems}
            pageRangeDisplayed={5}
            prevPageText={"Prev"}
            nextPageText={"Next"}
            disabled={this.state.isBusy}
            onChange={this.handlePageChange.bind(this)}/>
        </div>) : null;

    }

    renderTitleIndicator(){

        const maxItemsPerPage = this.getTotalItemsPerPage();
        const totalPages =  Math.ceil(this.state.totalItems / maxItemsPerPage);
        const noItems = this.state.totalItems === 0;

        switch (this.state.viewMode){
            case ViewMode.Normal:
                return noItems ? <p>Oops! Seems there's <b>nothing</b> here</p>  : <p>Showing page <b><NumberLabel value={this.state.activePage}/></b> - <b><NumberLabel value={totalPages}/></b> of <b><NumberLabel value={this.state.totalItems}/></b></p>;
            case ViewMode.Search:
                if(noItems)
                    return <p>No search <b>results</b> found!</p>;

                return (<p>Showing search results for '<b>{this.state.searchKeywordStatic}</b>' : <b><NumberLabel value={this.state.activePage}/></b> - <b><NumberLabel value={totalPages}/></b> of <b><NumberLabel value={this.state.totalItems}/></b></p>);
        }
    }

    renderActiveFilters(){

        const viewOptions = this.viewOptions;
        const viewFilters = viewOptions.filters;
        const filters = this._filterWrapper ? this._filterWrapper.getFilters().filters : {};
        return  <div className="mb-2">
            { Object.keys(filters).map((k,index) => {

                const flt = viewFilters.find(x => x.key === k);
                if(!flt || !flt.hasOwnProperty('name'))
                    return null;

                const _value = _.isFunction(flt.renderValue) ? flt.renderValue(filters[k],filters) : filters[k];
                if(_.isNil(_value))
                    return null;

                return <span key={k} className="ml-1">
                    <Chip label={<span><b>{flt.name || k}</b>: {_value}</span>}
                          {...Styles.chipStyle}
                          onDelete={() => {

                        this._filterWrapper.setFiltersRaw(filters => {
                            delete filters[k];
                            if(flt.hasOwnProperty('dependencies')){
                                flt.dependencies.forEach(d => delete filters[d]);
                            }

                            return filters;
                        });

                    }}/>
                </span>

            })}
        </div>
    }

    renderMainContent() {

        const state = this.state;
        const viewOptions =  this.viewOptions;
        const showDetails  = (viewOptions.detailsDisplay && this.viewOptions.detailsDisplay.enabled);
        const noItems = state.totalItems === 0 || (state.items.length === 0);
        const noSearchResults = state.viewMode === ViewMode.Search && noItems;
        const hasFilter = this._filterWrapper && this._filterWrapper.hasFilters(['page','itemsPerPage']);
        const isBusy = state.isBusy && !state.dialogOpen;
        const me = this;

        const tableParameters = (props) => ({
            disabled: isBusy,
            rows: state.items,
            columns: [],
            settings: {
                noRowsMessage: " ",
                rowClass: (r,item) => `${r} ${'clickable-row ' + (viewOptions.display && viewOptions.display.rowClass ? (viewOptions.display.rowClass(item)) : '')}`
            },
            onClickCell:(e,column,item) => {

                let _columnName = this.state.columns[column];
                if(_columnName && (me.state.dialogOpen ||  (_columnName.key === "__select" || _columnName.key === "__actions" || _columnName.key === "__img"))){
                    return;
                }

                if(showDetails){
                    me.beginShowDetails(item);
                }
                else{

                    if(viewOptions.processors.onItemClick)
                        viewOptions.processors.onItemClick(e,item);
                }
            },
            ...props
        });

        return   (<div>

            <Default>
                <div className="clearfix" style={{marginBottom: '10px'}}>
                    <div className="pull-left">
                        {this.renderTitleIndicator()}
                    </div>
                    {this.state.hasSearch &&
                    <div className="pull-right">
                        {this.state.hasSearch && this.renderSearch({ marginTop: -15  } )}
                    </div>}
                </div>
            </Default>

            <Mobile>

                <div className="text-center">
                    {this.renderTitleIndicator()}
                </div>

                {this.state.hasSearch && this.renderSearch({ width: "100%" , marginBottom: 10 })}

            </Mobile>

            <SortDialog ref={r => this._sortDlg = r} onApply={expr => {

                this.setStateSafe({
                    orderState: expr ? expr.split(",") : []
                },() => {
                    return this.refresh();
                });

            }}/>

            {this.state.hasToolbox && this.renderToolbox()}

            {this.renderCustomFilterView()}

            {hasFilter && this.renderActiveFilters()}

            <Default>
                <JsonTable {...tableParameters({
                    columns: this.state.columns
                })}  className={"table " + (noItems ? "" : `table-hover table-outline`)}/>
            </Default>

            <Mobile>
                <JsonTable {...tableParameters(({
                    columns: this.state.columnsMobile
                }))}  className={"table " + (noItems ? "" : `table-hover table-outline table-responsive`)}/>
            </Mobile>


            {noSearchResults && <div>

                {isBusy && <div className="text-center">
                    <Spinner name="three-bounce" color="green"/>
                    <p>Searching, please hold on...</p>
                </div>}

                {!isBusy && <div className="text-center" style={{marginBottom: '70px'}}>
                    <img className="img-rounded img-responsive" src="/img/search_icon.png" width={128} height={128}/>
                    <h4>No search results found for keyword '<b>{state.searchKeywordStatic}</b>'</h4>
                </div>}

            </div>}

            {noItems && state.viewMode === ViewMode.Normal && <div className="text-center" style={{marginBottom: '70px'}}>

                {isBusy && <div className="text-center">
                    <Spinner name="three-bounce" color="green"/>
                    <p>{viewOptions.busyMessage || "Please hold on..."}</p>
                </div>}

                {!isBusy && (state.faulted ?  <div>
                        <img src="/img/warning_icon.png" width={128} height={128}/>
                        <h5><b>Couldn't load page</b></h5>
                    </div>:
                    <div>
                        <img className="img-rounded img-responsive" src="/img/cloud_logo.png" width={128} height={128}/>
                        <h5><b>{hasFilter ? "No records match selected filter!" : viewOptions.noRowsMessage}</b></h5>
                    </div>)}


            </div>}

            <ProgressBar overlay={false} show={isBusy} />

            <div className="clearfix" style={{marginTop: '5px'}}>

                <div className="pull-left">
                    {/*Place something useful here*/}
                </div>

                <div className="pull-right">

                    {this.renderPagination()}

                </div>

            </div>

        </div>);
    }


    enterErrorState( errMessage , retryCallback) {

        this.retryCallback = retryCallback;

        this.setState({
            faulted: true,
            isBusy: false,
            isLoaded: false
        });

    }


    /**
     * Update item media
     * @param itemCopy
     * @param media
     */
    updateItemMedia(itemCopy,media){

        //  update copy reference media first
        itemCopy.media = media;
        let index = this.findItemIndex(itemCopy);

        if(index >= 0){

            let state= this.state.items;
            state[index].media = media;
            this.setState({
                items: state,
                editItem: itemCopy
            });
        }

    }

    /*
     * A hook for rendering extra content
     */
    renderExtra(){
        return null;
    }

    /*
     * Renders detail dialog content
     */
    renderDetailsContent(){

        const me = this;
        const item = this.state.detailItem;

        //  have custom renderer setup??
        if(this.viewOptions.detailsDisplay.customRender){
            return this.viewOptions.detailsDisplay.customRender(item);
        }

        if(!item)
            return;

        const columns = this.viewOptions.columns;

        return columns.map((col) => {

            return col.detailOnly ?  null : (<div className="row">
                <div className="col-md-4 text-muted">{col.label}</div>
                <div className="col-md-8">
                    <p>{ me.getCellValue(item,col.key)}</p>
                </div>
            </div>);
        });

    }

    toggleDialog(force = false){

        let open = !this.state.dialogOpen;
        if(!open && (this.state.preventDialogClose || this.state.isBusy) && !force){
            return;
        }

        if(!open){

            //  closing dialog
            this.beforeCloseDialog(this.state.activeDialog);

        }

        this.setState({
            dialogOpen: open,
            editItem: open? this.state.editItem  : null,
            deleteItem : open ? this.state.deleteItem :null
        });

    }

    beforeShowDialog(dialog){

        // console.log('Showing dialog - Id:' + dialog);

    }

    beforeCloseDialog(dialog){

        //  console.log('Closing dialog - Id: ' + dialog);

    }

    beginShowDialog(props){

        //  this for immediate effect
        this.state.dialogOpen = true;

        if(typeof props === 'number') {

            //
            this.beforeShowDialog(props);

            this.setState({
                dialogOpen: this.state.dialogOpen,
                activeDialog: props
            });

        }
        else {

            let state = {dialogOpen: this.state.dialogOpen};
            let fs = props ? _.merge(state, props) : state;

            //
            if(fs.hasOwnProperty('activeDialog')){
                this.beforeShowDialog(fs.activeDialog,fs);
            }

            this.setState(fs);
        }
    }


    onSubmitCreateOrEdit(values){

        const me = this;
        const dialogToggle = this.toggleDialog;

        let promise;
        if(this.state.editItem)
            promise = this.onEditItem(values);
        else
            promise = this.onCreate(values);

        //  toggle after process is complete
        if(promise)
            promise.then((succeeded) => {

            if(succeeded){
                me.persistSession();
                dialogToggle(true);
            }

            } ).catch((proceed) => proceed  ? dialogToggle(true) : null  )


    }


    renderDialogs(dialog){

        const dialogToggle = this.toggleDialog;
        const dialogOpen = this.state.dialogOpen;
        const isBusy = this.state.isBusy;
        let contextItem;
        const me = this;

        switch (dialog) {

            //  Confirm Dialog
            case Dialogs.Confirm: {

                return (<Modal toggle={dialogToggle} isOpen={dialogOpen}>
                    <ModalHeader toggle={dialogToggle}>{this.state.confirmTitle}</ModalHeader>
                    <ModalBody>{this.state.confirmMessage}</ModalBody>
                    <ModalFooter>
                        <Button style={{borderRadius: 4}} onClick={dialogToggle}>{this.state.confirmCancelText}</Button>
                        <Button style={{borderRadius: 4}} onClick={() => {

                            //  invoke accepted handler
                            this.state.confirmAcceptedHandler();

                            //  toggle dialog
                            dialogToggle();

                        }} color={this.state.confirmBtnColor || "primary"}>{this.state.confirmPositiveText}</Button>
                    </ModalFooter>
                </Modal>);
            }
            //  Create or Edit Dialog
            case Dialogs.CreateOrEdit: {

                contextItem = this.state.editItem;
                const inputs = (contextItem != null ? this.viewOptions.inputsEdit : this.viewOptions.inputsCreate ) || this.viewOptions.inputs;

                return (<Modal isOpen={dialogOpen} toggle={dialogToggle}  onOpened={() => {

                    //  we're entering editing mode
                    if (me.state.editItem) {
                        me._createEditRenderer.bindItem(me.state.editItem, true);
                    }

                }}>
                    <ModalHeader toggle={dialogToggle}>{contextItem ? this.viewOptions.actions.create.editTitleMsg : this.viewOptions.actions.create.createTitleMsg}</ModalHeader>
                    <ModalBody>

                            <FormRenderer inputs={typeof inputs === "function" ? inputs() : inputs }
                                          busy={isBusy}
                                          postInputFormat
                                          onSubmit={this.onSubmitCreateOrEdit.bind(this)}
                                          setInputValue={this.viewOptions.processors.setInputValue}
                                          inputStyle={this.viewOptions.styles ? this.viewOptions.styles.formInputStyle : null}
                                          showStatusError={true}
                                          getInputValue={this.viewOptions.processors.getInputValue}
                                          ref={renderer => {
                                              this._createEditRenderer = renderer
                                          }}>
                                <hr/>

                                {isBusy && <ProgressBar show={true} overlay={true}/> }

                                <div className="w-100">

                                    <Button block className="btn btn-default add-button" type="submit" disabled={isBusy}>
                                        {
                                            contextItem ?
                                                <span>
                                        <i className="fa fa-edit"></i> Save Changes
                                    </span> :
                                                <span>
                                        <i className="fa fa-plus"></i> {this.viewOptions.actions.create.text}
                                    </span>
                                        }
                                    </Button>


                                </div>

                            </FormRenderer>

                    </ModalBody>
                </Modal>);
            }
            case Dialogs.Details: {
                const viewOptions = this.viewOptions;
                const actions = viewOptions.actions;
                const details = this.viewOptions.detailsDisplay;


                contextItem = this.state.detailItem;

                return (<Modal toggle={dialogToggle} isOpen={dialogOpen} className={details.large ? 'modal-lg' : null}
                               onOpened={() => {

                                   if(_.isFunction(details.onShow))
                                       details.onShow(contextItem);

                               }}
                               contentClassName="modal-default-padding"
                               keyboard={true}>
                    <ModalHeader toggle={dialogToggle}
                                 style={Styles.modalHeader}>{details.renderTitle(contextItem)}</ModalHeader>
                    <ModalBody>
                        {this.renderDetailsContent()}
                        {isBusy && <ProgressBar show={true} overlay={true}/>}
                    </ModalBody>
                    {details.renderFooter ? details.renderFooter(contextItem) : <ModalFooter>
                        <div className="clearfix w-100">

                            <Confirm ref={r => this._confirmDeleteDlg = r}
                                     title={this.viewOptions.actions.delete.confirmTitle}
                                     confirmBtnColor="danger"
                                     body={this.viewOptions.actions.delete.confirmMessage}
                                     confirmText={this.viewOptions.actions.delete.text}
                                     cancelText={'Cancel'}
                                     onConfirm={() => {

                                         return this.onDeleteItem(() => {
                                             this.toggleDialog(true);

                                         }, contextItem);

                                     }}/>

                            <div className="pull-right">
                                <Button color="link" onClick={dialogToggle}>Cancel</Button>
                            </div>

                            <div className="pull-left">
                                {actions.edit.enabled && <PermissionRender required={actions.edit.permissions}>
                                <Button style={{borderRadius: 4}} outline={true} color={"primary"} onClick={() => {

                                    this.setState({
                                        dialogOpen: false,
                                    }, () => {

                                        window.setTimeout(() => {
                                            this.beginEdit(contextItem);
                                        }, 450);

                                    });


                                }}><i className="fa fa-edit"/> Edit</Button>
                                </PermissionRender>}

                                {(actions.delete.enabled && (typeof actions.delete.isAllowed == "function" ? actions.delete.isAllowed(contextItem) : true ) ) &&
                                <PermissionRender required={actions.delete.permissions}>
                                    <Button style={{marginLeft: 5, borderRadius: 4}} outline={true} color={"danger"}
                                        onClick={() => {

                                            this._confirmDeleteDlg.show()

                                        }}><i className="fa fa-remove"/> Delete</Button>
                                </PermissionRender> }

                                {details.hasOwnProperty('renderActions') && details.renderActions(contextItem,{ toggle: this.toggleDialog.bind(this) }).map((action,k) => {

                                    return <PermissionRender required={action.permissions} key={k}>
                                        <Button style={{marginLeft: 5, borderRadius: 4}} outline={true} color={action.color}
                                                onClick={action.onClick}>{HTML.renderIcon(action.icon)} {action.label}</Button>
                                    </PermissionRender>
                                })}

                            </div>

                        </div>
                    </ModalFooter>}
                </Modal>);
            }
        }

    }

    /**
     * Determines there's no other action running and in idle state
     * @returns {boolean}
     */
    isValidState(){
        const state = this.state;
        return !state.isBusy && state.errorMessage === null && state.isLoaded;
    }

    renderFaultedView(){

        return this.state.faulted && <div className="card-footer card-error">
            <div className="clear-fix">

                <div className="pull-left">
                    {this.state.isBusy ? <Spinner name="chasing-dots" color="white"/>: <p>An error occurred while loading page. Try refreshing...</p>}
                </div>

                <div className="pull-right">
                    <Button color="default" className="error-refresh-button" disabled={this.state.isBusy} onClick={() => this.refresh()}><i className="fa fa-refresh"></i> Refresh</Button>
                </div>

            </div>

        </div>;
    }

    _handleQueryChange({ filters , page, limit }){

        const { search } = filters;

        this.setStateSafe({
            searchKeyword: search,
            searchKeywordStatic: search,
            viewMode: search ? ViewMode.Search : ViewMode.Normal,
            activePage: page,
            maxItemsPerPage: limit,
            customFilterState: this.getCustomFilterState(filters)
        }, () => this.refresh());

    }

    _handleEvent(event,data){

        switch (event) {
            case 'refresh_active_view':
                return this.onRefreshActiveView();
        }
    }

    /**
     * Returns default filters
     * @returns {{query: string, name: string, key: string}[]}
     */
    getDefaultFilters(){

        return [
            {
                key: 'filterId',
                filterKey: 'id',
                query: 'filter_id',
                apply: true,
            },
            {
                key: 'orderBy',
                query: 'order_by'
            }
        ];

    }

    render() {

        const viewOptions = this.viewOptions;
        const renderHooks = viewOptions.renderHooks || {};

        return <DocumentTitle title={viewOptions.pageTitle || AppVariables.AppCompanyName }>

            <ActiveView view={this}>

                <EventListener events={[ 'refresh_active_view' ]}
                               onEvent={this._handleEvent}>

                    <FilterQueryWrapper ref={r => this._filterWrapper = r}
                                        defaultFilters={this.getDefaultFilters()}
                                        enableSearch={this.state.hasSearch}
                                        initialItemsPerPage={this.getTotalItemsPerPage()}
                                        filters={viewOptions.filters}
                                        onChange={this._handleQueryChange}>

                        <PlatformContainer title={viewOptions.pageTitle}
                                           icon={viewOptions.pageIcon}
                                           noFrame={true}
                                           renderError={this.renderFaultedView.bind(this)}
                                           renderHead={() => renderHooks.header && renderHooks.header()}
                                           renderFooter={() => <div>
                                                {this.renderDialogs(this.state.activeDialog)}
                                                { renderHooks.footer && renderHooks.footer()}
                                           </div>}>
                            {this.renderMainContent()}
                            {this.renderExtra()}
                        </PlatformContainer>

                    </FilterQueryWrapper>

                </EventListener>

            </ActiveView>
        </DocumentTitle>;
    }
}


CRUDView.defaultProps = {
    __isCRUDView: true  // CRUD view component marker
};

export default CRUDView;



// WEBPACK FOOTER //
// ./src/components/CRUDView/CRUDView.js